import get from 'transmute/get';
import { PreviewConfigContext, PreviewConfigRecord
// @ts-expect-error untyped dependency
} from './context/PreviewConfigContext';
import { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LegacyPreviewContextProvider({
  setPreviewConfig,
  logPreviewSidebarObject,
  subjectId,
  objectType,
  children,
  shouldOpenOnRender,
  closeSidebar
}) {
  const handleSetPreviewConfig = useCallback(config => {
    const objectTypeId = get('objectTypeId', config);
    logPreviewSidebarObject(objectTypeId);
    setPreviewConfig(config);
  }, [setPreviewConfig, logPreviewSidebarObject]);
  useEffect(() => {
    if (shouldOpenOnRender) {
      handleSetPreviewConfig(PreviewConfigRecord({
        objectTypeId: objectType,
        objectId: subjectId
      }));
    }
  }, [shouldOpenOnRender, handleSetPreviewConfig, objectType, subjectId]);
  const contextValue = useMemo(() => ({
    setPreviewConfig: handleSetPreviewConfig,
    closeSidebar,
    fromObjectId: subjectId,
    fromObjectType: objectType
  }), [handleSetPreviewConfig, objectType, subjectId, closeSidebar]);
  return /*#__PURE__*/_jsx(PreviewConfigContext.Provider, {
    value: contextValue,
    children: children
  });
}
LegacyPreviewContextProvider.propTypes = {
  objectType: PropTypes.string.isRequired,
  closeSidebar: PropTypes.func.isRequired,
  logPreviewSidebarObject: PropTypes.func.isRequired,
  setPreviewConfig: PropTypes.func.isRequired,
  subjectId: PropTypes.string.isRequired,
  shouldOpenOnRender: PropTypes.bool.isRequired
};